<p class="text-info mb-xlg">Puedes seleccionar una opción para asignarle un plan de alimentación al paciente.</p>
<app-options-meal-plan
  [shadow]="false"
  [showOptionsActivePlan]="false"
  [showDownloadOption]="false"
  [temporalMealPlan]="mealPlanClass"
  [mealPlanAppointment]="patientPlan?.mealPlanAppointment"
  (optionSelected)="optionMealPlanSelected($event)"></app-options-meal-plan>
